import { Form, Input, Modal } from "antd";
import React, { useState } from "react";
import { DeleteOutlined } from "@ant-design/icons";

export default function Medication(props: any) {
  const { medication, onDelete } = props;
  const [form] = Form.useForm();
  const [open, setOpen] = useState(false);

  type FieldType = {
    medicine?: string;
    dose?: string;
    route?: string;
    dosage?: string;
    period?: string;
  };

  const hideModal = () => {
    setOpen(false);
  };

  const handleDelete = () => {
    onDelete(medication);
  };

  const getValues = () => {
    form
      .validateFields()
      .then((values) => {
        hideModal();
      })
      .catch((errorInfo) => {});
  };

  return (
    <div className="overflow-auto p-2">
      <div className="border rounded-md">
        <table className="w-full divide-y divide-gray-300">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-2 py-2 text-xs text-gray-500">Medicine</th>
              <th className="px-2 py-2 text-xs text-gray-500">Dose</th>
              <th className="px-2 py-2 text-xs text-gray-500">Route</th>
              <th className="px-2 py-2 text-xs text-gray-500">Dosage</th>
              <th className="px-2 py-2 text-xs text-gray-500">Period</th>
              <td className="px-2 py-2 text-center">
                <DeleteOutlined
                  onClick={handleDelete}
                  style={{ color: "red" }}
                  className="cursor-pointer"
                />
              </td>
            </tr>
          </thead>

          <tbody className="bg-white divide-y divide-gray-200">
            <tr className="whitespace-nowrap">
              <td className="px-4 py-2 text-sm text-gray-500 text-center">
                {medication?.medicine}
              </td>
              <td className="px-4 py-2 text-sm text-gray-900 text-center">
                {medication?.dose}
              </td>
              <td className="px-4 py-2 text-sm text-gray-500 text-center">
                {medication?.route}
              </td>
              <td className="px-4 py-2 text-sm text-gray-500 text-center">
                {medication?.dosage}
              </td>
              <td className="px-4 py-2 text-sm text-gray-500 text-center">
                {medication?.period}
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <Modal
        title="Medication List"
        open={open}
        onOk={getValues}
        onCancel={hideModal}
        okText="Save"
        okButtonProps={{
          type: "default",
        }}
        cancelText="Cancel"
      >
        <div>
          <Form layout="vertical" form={form}>
            <Form.Item<FieldType>
              label="Medicine"
              name="medicine"
              rules={[{ required: true, message: "Please input medicine!" }]}
            >
              <Input placeholder="Pregnacare, Ideos.." />
            </Form.Item>
            <Form.Item<FieldType>
              label="Dose"
              name="dose"
              rules={[{ required: true, message: "Please input a dose!" }]}
            >
              <Input placeholder="1" />
            </Form.Item>

            <Form.Item<FieldType>
              label="Route"
              name="route"
              rules={[
                {
                  required: true,
                  message:
                    "Please input how the medicine will be administered!",
                },
              ]}
            >
              <Input placeholder="Oral use" />
            </Form.Item>

            <Form.Item<FieldType>
              label="Dosage"
              name="dosage"
              rules={[{ required: true, message: "Please input dosage!" }]}
            >
              <Input placeholder="1 per day.." />
            </Form.Item>
            <Form.Item<FieldType>
              label="Period"
              name="period"
              rules={[{ required: true, message: "Please input the period!" }]}
            >
              <Input placeholder="30 days" />
            </Form.Item>
          </Form>
        </div>
      </Modal>
    </div>
  );
}
